import React, { useState, useEffect } from 'react';
import RequestCodeSection from '../../ApiTestSection/RequestCodeSection';
import useRequestGenerator from '../hooks/useRequestGenerator';

/**
 * EndpointRequestSection - Displays the generated request code for an endpoint
 * Shows cURL and Fetch format options
 *
 * @param {string} method - HTTP method (GET, POST, etc.)
 * @param {string} endpoint - API endpoint path
 * @param {Array} parameters - Array of API parameters
 * @param {Object} requestBody - Request body schema
 * @param {Object} fullSpec - Full OpenAPI specification
 * @param {string} serverUrl - Base server URL
 * @param {Object} formValues - Form values for parameters (optional)
 */
const EndpointRequestSection = ({
  method,
  endpoint,
  parameters = [],
  requestBody = {},
  fullSpec,
  serverUrl = '',
  formValues = {},
}) => {
  const [requestFormat, setRequestFormat] = useState('curl');
  const [request, setRequest] = useState('');

  const { generateRequest } = useRequestGenerator({
    method,
    endpoint,
    parameters,
    requestBody,
    fullSpec,
    serverUrl,
    formValues,
  });

  // Update request when dependencies change
  useEffect(() => {
    const newRequest = generateRequest(requestFormat, formValues);
    setRequest(newRequest);
  }, [requestFormat, formValues, generateRequest]);

  return <RequestCodeSection request={request} requestFormat={requestFormat} setRequestFormat={setRequestFormat} />;
};

export default EndpointRequestSection;
